import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColorSwatchContext = /*#__PURE__*/createContext(undefined);
export const ColorSwatchProvider = ({
  buttonStyleOverrides,
  iconCircleStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    buttonStyleOverrides,
    iconCircleStyleOverrides
  }), [buttonStyleOverrides, iconCircleStyleOverrides]);
  return /*#__PURE__*/_jsx(ColorSwatchContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `ColorSwatch` component.
 * Note: The context is only available when the `ColorSwatch` component is rendered as an ancestor.
 * @returns ColorSwatchContext - The context for the `ColorSwatch` component.
 * @returns ColorSwatchContext.buttonStyleOverrides - CSS overrides to apply to the `Button` component.
 * @returns ColorSwatchContext.iconCircleStyleOverrides - CSS overrides to apply to the `IconCircle`/`IconHolder` component.
 */
export const useColorSwatchContext = () => {
  const colorSwatchContext = useContext(ColorSwatchContext);
  return colorSwatchContext;
};